import React from "react";
import { FormattedMessage } from "react-intl";
import { Card, CardBody, CardFooter, CardHeader, ListGroup, ListGroupItem } from "reactstrap";
import { Link, NavLink as NavLinkRRD } from "react-router-dom";
import { useAccessory } from "../../context/AccessoryContext";

function AccessoryProgress({ items, onNext, onPrevious }) {
  const { accessory, isNewAccessory } = useAccessory();
  const itemKeys = Object.keys(items);
  const isReadOnly = accessory?.isReadOnly || false;

  return (
    <Card className="product-progress">
      <CardHeader>
        {isReadOnly ? (
          <FormattedMessage id="accessories.view_accessory.title" defaultMessage="View a accessory" />
        ) : isNewAccessory ? (
          <FormattedMessage id="accessories.new_accessory.title" defaultMessage="Create a new accessory" />
        ) : (
          <FormattedMessage id="accessories.edit_accessory.title" defaultMessage="Edit a accessory" />
        )}
      </CardHeader>
      <CardBody className="p-0">
        <ListGroup flush>
          {itemKeys.map((key, i) => (
            <ListGroupItem
              key={i}
              className="d-flex align-items-center"
              to={items[key].to}
              //onClick={(e) => e.preventDefault()}
              disabled={items[key].disabled || false}
              activeClassName="active"
              tag={NavLinkRRD}
              style={{ cursor: "default" }}
            >
              <span className="flex-grow-1">
                {i + 1}. {items[key].description}
              </span>
            </ListGroupItem>
          ))}
        </ListGroup>
      </CardBody>
      <CardFooter>
        {onNext && (
          <button className="btn btn-outline-dark float-right" onClick={onNext}>
            <FormattedMessage id="app.next" defaultMessage="Next" />
          </button>
        )}
        {onPrevious && (
          <button type="button" className="btn btn-outline-danger" onClick={onPrevious}>
            <i className="fas fa-arrow-left"></i> <FormattedMessage id="app.back" defaultMessage="Back" />
          </button>
        )}
      </CardFooter>
    </Card>
  );
}

export default AccessoryProgress;
